import React, { useEffect } from 'react'
import HighchartsReact from 'highcharts-react-official'
import Highcharts from 'highcharts/highstock'
const Barchart = ({ options, highcharts }) => {
  useEffect(() => {
    Highcharts.chart('container1', {
      chart: {
        type: 'column',
        style: {
          fontFamily: 'Roboto, sans-serif'
      }
    },
      title: {
        text: 'Enrollment Rate'
      },

      // subtitle: {
      //   text: 'Source: thesolarfoundation.com'
      // },

      yAxis: {
        title: {
          text: 'Count'
        }
      },

      xAxis: {
        accessibility: {
          rangeDescription: 'Month'
        },
        title: {
          text: 'Month'
        },
        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      },

      legend: {
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'middle'
      },

      // plotOptions: {
      //   series: {
      //     label: {
      //       connectorAllowed: false
      //     },
      //     pointStart: January
      //   }
      // },
      credits: {
        enabled: false
      },
      series: [{
        name: 'Planned',
        data: [30, 40, 35, 50, 70, 20, 90]
      },
      {
        name: 'Actual',
        data: [20, 30, 60, 50, 40, 30, 70]
      }
      ],

      responsive: {
        rules: [{
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom'
            }
          }
        }]
      }
    });
  }, [])
  return (
    <div id="container1" ></div>
    // <Highcharts
    //   highcharts={Highcharts}
    //   // constructorType={'chart'}
    //   options={chartOptions}
    // />
  )
}


export default Barchart